import { SupportSMS } from "./smsTypes"
import { AxiosInstance } from "axios"

export enum SupportReportsSMSQuery {
    SMS_FOR_SUPPORT = "sms-for-support",
}

type SupportSMSParams = Readonly<{
    phoneNumber?: string
    text?: string
    from?: string
    to?: string
}>

export type SupportSMSResponse = Readonly<{
    sms: SupportSMS[]
}>

export async function fetchSupportMessagesSMS(
    { from, to, phoneNumber, text }: SupportSMSParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupportSMSResponse> {
    const url = "/sms"

    const { data } = await axios.get(url, {
        params: {
            phoneNumber,
            text,
            from,
            to,
        },
        signal,
    })

    return data
}
